const MERGE_ARRAY_KEYS = [
  "combinedDoors",
  "complianceChecks",
  "physicalMeasurements",
  "additionalInfos",
  "inspectedDoors",
  "doorSummaryDto",
];

export function mergeChunkCache(chunkCache) {
  const chunkIds = Object.keys(chunkCache)
    .map(Number)
    .filter((n) => !Number.isNaN(n))
    .sort((a, b) => a - b);

  if (chunkIds.length === 0) return null;

  const first = chunkCache[chunkIds[0]];
  if (!first) return null;

  const merged = {
    ...first,
    propertyInspectionReport: {
      ...(first.propertyInspectionReport ?? {}),
    },
  };

  const pir = merged.propertyInspectionReport;

  MERGE_ARRAY_KEYS.forEach((key) => {
    pir[key] = [...(first.propertyInspectionReport?.[key] ?? [])];
  });

  for (let i = 1; i < chunkIds.length; i++) {
    const chunk = chunkCache[chunkIds[i]];
    const chunkPir = chunk?.propertyInspectionReport;
    if (!chunkPir) continue;

    MERGE_ARRAY_KEYS.forEach((key) => {
      const next = chunkPir[key];
      if (next?.length) {
        pir[key] = [...(pir[key] ?? []), ...next];
      }
    });
  }

  return merged;
}

export function getStaticReportData(chunkCache) {
  return chunkCache[1] ?? null;
}
